import {
    ADMIN_PORTAL_UNLEASH_CLIENT_KEY,
    ADMIN_PORTAL_UNLEASH_URL,
} from '@tools/constants';

/**
 * Maps environment names to application names used in GitLab Unleash.
 *
 * @param environment - The environment name
 * @returns The application name for GitLab Unleash
 */
export const getAppNameForEnvironment = (environment: string): string => {
    switch (environment) {
        case 'production':
            return 'eon-hems-prod';
        case 'qa':
            return 'eon-hems-qa';
        case 'development':
            return 'eon-hems-dev';
        default:
            return 'test';
    }
};

// Determine current environment
const currentEnv = process.env.NODE_ENV || 'development';
const isLocalEnvironment = Boolean(
    window.location.hostname === 'localhost' ||
        window.location.hostname === '[::1]' ||
        window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
        ),
);

export const ENVIRONMENT = process.env.NODE_ENV || 'development';
export const APP_NAME = getAppNameForEnvironment(ENVIRONMENT) || '';

export const USER_AGENT_HEADER = APP_NAME;
export const AUTHORIZATION_HEADER = ADMIN_PORTAL_UNLEASH_CLIENT_KEY || '';
export const UNLEASH_APPNAME_HEADER = APP_NAME;
export const UNLEASH_INSTANCEID_HEADER = ADMIN_PORTAL_UNLEASH_CLIENT_KEY || '';
export const UNLEASH_CLIENT_SPEC_HEADER = '4.3.0';

export const unleashConfig = {
    url: ADMIN_PORTAL_UNLEASH_URL || '',
    clientKey: ADMIN_PORTAL_UNLEASH_CLIENT_KEY || '',
    appName: APP_NAME,
    environment: currentEnv,
    refreshInterval: 15000,
    metricsInterval: 30000,
    disableMetrics: isLocalEnvironment,
    customHeaders: {
        'UNLEASH-APPNAME': UNLEASH_APPNAME_HEADER,
        'User-Agent': USER_AGENT_HEADER,
        'UNLEASH-INSTANCEID': UNLEASH_INSTANCEID_HEADER,
        'Unleash-Client-Spec': UNLEASH_CLIENT_SPEC_HEADER,
        Authorization: AUTHORIZATION_HEADER,
        Accept: '*/*',
        'Accept-Encoding': 'gzip,deflate',
    },
};
